import { create } from 'zustand';

interface AppChromeState {
  isSidebarHidden: boolean;
  isSupportSheetOpen: boolean;
}

const useAppChromeStore = create<AppChromeState>(() => ({
  isSidebarHidden: false,
  isSupportSheetOpen: false,
}));

/**
 * Whether a page has asked the app sidebar to step out of the way, for a view that wants the
 * whole window. The shell mounts once for the entire dashboard route group, so a page cannot
 * reach it by composition and sets this instead - which also makes clearing it the setter's job:
 * a page that leaves this `true` on unmount takes the sidebar away from every route after it.
 */
export const useIsAppSidebarHidden = (): boolean => useAppChromeStore((s) => s.isSidebarHidden);

export const setAppSidebarHidden = (isSidebarHidden: boolean): void => {
  useAppChromeStore.setState({ isSidebarHidden });
};

/**
 * The sidebar's Support item opens a sheet the shell cannot render itself: widgets may not
 * import features, so the sheet is mounted above the router and reads this instead.
 */
export const useIsSupportSheetOpen = (): boolean => useAppChromeStore((s) => s.isSupportSheetOpen);

export const setSupportSheetOpen = (isSupportSheetOpen: boolean): void => {
  useAppChromeStore.setState({ isSupportSheetOpen });
};
